import React from "react";

import Portfolio from "components/Tvendo/Article/DataMaster/Portfolio/List.js";

export default function () {
  return <Portfolio />;
}
